import {
    apiRequest,
    PunishmentPeriodList,
    PromotionPeriodApprove,
    PunishmentPeriodDelete,
    PunishmentManualList,
} from "../../../../../services/adapters/kepegawaian/hukdisService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", PunishmentPeriodList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    fetchManualRowTable = async (query, cancelToken) => {
        return await apiRequest("get", PunishmentManualList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }
    
    fetchCreate = async (query) => {
        return await apiRequest("post", PromotionPeriodApprove, {
            body: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", PunishmentPeriodDelete, {
            body: query
        }, true)
    }

}

export default DataTableRepository